
  import createMeisterIcons from '../src/createMeisterIcons';

  const ReactangleHalf = createMeisterIcons("reactangle-half", [["path",{"fill":"currentColor","d":"M5.75 7A3.26 3.26 0 0 1 9 3.75h6A3.26 3.26 0 0 1 18.25 7v4.25H5.75zm0 5.75V17A3.26 3.26 0 0 0 9 20.25h6A3.26 3.26 0 0 0 18.25 17v-4.25zM9 2.25A4.76 4.76 0 0 0 4.25 7v10A4.76 4.76 0 0 0 9 21.75h6A4.76 4.76 0 0 0 19.75 17V7A4.76 4.76 0 0 0 15 2.25z","key":"6ad8c8397c7295675cc6376c6ee1e373ef2f0832","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default ReactangleHalf
  